import { requiresAdmin, requiresPA } from "./routeGuards";

export const asyncRoutes = [
  // Root route
  {
    path: "/",
    meta: {
      requiresAuth: false
    },
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/auth/Home.vue")
  },

  // Admin routes
  {
    path: "/admin/create-ea-account",
    name: "CreatePAAccount",
    meta: {
      assistants: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "create-ea-account" */ "@/views/admin/CreatePAAccount.vue"
      ),
    beforeEnter: requiresAdmin
  },
  {
    path: "/admin/add-customer",
    name: "AddCustomer",
    meta: {
      customers: true,
      requiresAuth: true
    },
    beforeEnter: requiresAdmin,
    component: () =>
      import(
        /* webpackChunkName: "add-customer" */ "@/views/admin/AddCustomer.vue"
      )
  },
  {
    path: "/admin/new-customer-intake/:pid",
    name: "CustomerIntake",
    meta: {
      customers: true,
      requiresAuth: true
    },
    beforeEnter: requiresAdmin,
    component: () =>
      import(
        /* webpackChunkName: "customer-intake" */ "@/views/admin/NewCustomerIntake.vue"
      )
  },
  {
    path: "/admin/assign-ea/:id",
    name: "AssignPAtoCustomer",
    meta: {
      customers: true,
      requiresAuth: true
    },
    beforeEnter: requiresAdmin,
    component: () =>
      import(
        /* webpackChunkName: "assign-ea-to-customer" */ "@/views/admin/AssignPAtoCustomer"
      )
  },
  {
    path: "/admin/customers",
    name: "CustomersListAdmin",
    meta: {
      customers: true,
      requiresAuth: true
    },
    beforeEnter: requiresAdmin,
    component: () =>
      import(
        /* webpackChunkName: "customers-list-admin" */ "@/views/admin/customers/CustomersList.vue"
      )
  },
  {
    path: "/admin/companies",
    name: "CompanyListAdmin",
    meta: {
      companies: true,
      requiresAuth: true
    },
    beforeEnter: requiresAdmin,
    component: () =>
      import(
        /* webpackChunkName: "companies-list-admin" */ "@/views/admin/companies/CompaniesList.vue"
      )
  },

  // Common routes
  {
    path: "/customer-details/:profileId/add-preference",
    name: "AddPreference",
    meta: {
      customers: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "add-preference" */ "@/views/customer/preferences/AddPreference.vue"
      )
  },
  {
    path: "/customer-details/:profileId/view-preference/:prefID",
    name: "ViewEditPreference",
    meta: {
      customers: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "view-edit-preference" */ "@/views/customer/preferences/ViewEditPreference.vue"
      )
  },
  {
    path: "/ea/:uuid/customer-details/:profileId/add-preference",
    name: "PAAddPreference",
    meta: {
      assistants: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "ea-add-preference" */ "@/views/customer/preferences/AddPreference.vue"
      )
  },
  {
    path: "/ea/:uuid/customer-details/:profileId/view-preference/:prefID",
    name: "PAViewPreference",
    meta: {
      assistants: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "ea-view-preference" */ "@/views/customer/preferences/ViewEditPreference.vue"
      )
  },

  {
    path: "/ea/:uuid/details/",
    name: "PADetails",
    meta: {
      assistants: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "details" */ "@/views/assistant/PADetails.vue"
      )
  },

  {
    path: "/admin/:uuid/details/",
    name: "AdminDetails",
    meta: {
      assistants: true,
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "details" */ "@/views/admin/AdminDetails.vue")
  },

  {
    path: "/ea/:uuid/customer-details/:profileId",
    name: "PACustomerDetails",
    meta: {
      assistants: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "ea-customer-details" */ "@/views/customer/CustomerDetails.vue"
      )
  },

  {
    path: "/ea/:uuid/customer-details/:profileId/task/:id",
    name: "ViewPACustomerTask",
    meta: {
      assistants: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "view-ea-customer-task" */ "@/views/common/ViewTask.vue"
      )
  },
  {
    path: "/ea/:uuid/task/:id",
    name: "ViewPATask",
    meta: {
      assistants: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "view-ea-task" */ "@/views/common/ViewTask.vue"
      )
  },

  {
    path: "/ea-directory/",
    name: "ViewPADirectory",
    meta: {
      assistants: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "ea-directory" */ "@/views/assistant/ViewPADirectory.vue"
      )
  },

  {
    path: "/customer-details/:profileId/task/:id",
    name: "ViewCustomerTask",
    meta: {
      customers: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "view-customer-task" */ "@/views/common/ViewTask.vue"
      )
  },

  {
    path: "/customers/build-client-intake/:profileId",
    name: "ClientIntake",
    meta: {
      customers: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "build-client-intake" */ "@/views/customer/build-client-intake/ClientIntake"
      )
  },
  {
    path: "/customer-details/:profileId",
    name: "CustomerDetails",
    meta: {
      customers: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "customer-details" */ "@/views/customer/CustomerDetails.vue"
      )
  },

  {
    path:
      "/customer-details/:profileId/weekly-tasks/:assistantId/details/:notesId",
    name: "ViewWeeklyTaskCustomer",
    meta: {
      customers: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "view-weekly-task-customer" */ "@/views/common/tasks/weekly/ViewEditWeekly.vue"
      )
  },
  {
    path: "/add-task/:statusID/:frequency",
    name: "AddTask",
    meta: {
      tasks: true,
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "add-task" */ "@/views/common/AddTasks.vue")
  },
  {
    path: "/task/:id",
    name: "ViewTask",
    meta: {
      tasks: true,
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "task" */ "@/views/common/ViewTask.vue")
  },
  {
    path: "/resources",
    name: "Resources",
    meta: {
      resources: true,
      requiresAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "resources" */ "@/views/common/Resources.vue")
  },
  {
    path: "/resources/categories",
    name: "CategoriesList",
    meta: {
      resources: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "categories" */ "@/views/admin/CategoriesList.vue"
      )
  },
  {
    path: "/resources/categories/add-category",
    name: "AddCategory",
    meta: {
      resources: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "categories" */ "@/views/common/AddViewCategory.vue"
      )
  },
  {
    path: "/resources/categories/view-category/:id",
    name: "ViewCategory",
    meta: {
      resources: true,
      isViewMode: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "categories" */ "@/views/common/AddViewCategory.vue"
      )
  },
  {
    path: "/resources/tips",
    name: "TipsList",
    meta: {
      resources: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "categories" */ "@/views/admin/TipsList.vue"
      )
  },
  {
    path: "/resources/tips/add-tip",
    name: "AddTip",
    meta: {
      resources: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "categories" */ "@/views/common/AddTip.vue"
      )
  },
  {
    path: "/reports-list/",
    name: "ReportsList",
    meta: {
      reports: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "reports-list" */ "@/views/common/reports/ReportsList.vue"
      )
  },
  {
    path: "/reports-details/:profileId/:from/:to",
    name: "ReportDetails",
    meta: {
      reports: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "report-details" */ "@/views/common/reports/ReportDetails.vue"
      )
  },
  {
    path: "/capacity/",
    name: "Capacity",
    meta: {
      capacity: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "capacity" */ "@/views/common/capacity/Capacity.vue"
      ),
    beforeEnter: requiresAdmin
  },
  {
    path: "/profile-settings/",
    name: "ProfileSettings",
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "profile-settings" */ "@/views/common/ProfileSettings.vue"
      )
  },
  {
    path: "/tasks/task-dashboard",
    name: "TaskDashboard",
    meta: {
      tasks: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "task-dashboard" */ "@/views/common/tasks/taskdashboard/TaskDashboard.vue"
      )
  },
  {
    path: "/tasks/handover-tasks/:tab",
    name: "HandoverTasks",
    meta: {
      tasks: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "handover-tasks" */ "@/views/common/tasks/HandoverTasks.vue"
      )
  },

  // PA routes
  {
    path: "/customer-details/:profileId/weekly-tasks/add-weekly-task",
    name: "AddWeeklyTaskCustomer",
    meta: {
      customers: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "add-weekly-task-customer" */ "@/views/common/tasks/weekly/AddWeekly.vue"
      )
  },
  {
    path: "/customer-details/:profileId/add-task/:statusID/:frequency",
    name: "AddCustomerTask",
    meta: {
      customers: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "add-customer-task" */ "@/views/common/AddTasks.vue"
      )
  },
  {
    path: "/customers/dedicated",
    name: "DedicatedCustomers",
    meta: {
      customers: true,
      customerNavTabs: true,
      requiresAuth: true,
      // Owners share this list; it renders read-only for them and the
      // API only ever returns the customers assigned to them.
      ownerAllowed: true
    },
    beforeEnter: requiresPA,
    component: () =>
      import(
        /* webpackChunkName: "dedicated-customers" */ "@/views/assistant/DedicatedCustomers.vue"
      )
  },
  {
    path: "/customers/handover",
    name: "HandoverCustomers",
    meta: {
      customers: true,
      customerNavTabs: true,
      requiresAuth: true
    },
    beforeEnter: requiresPA,
    component: () =>
      import(
        /* webpackChunkName: "handover-customers" */ "@/views/assistant/HandoverCustomers.vue"
      )
  },
  {
    path: "/customers/archived",
    name: "PAArchivedCustomers",
    meta: {
      customers: true,
      customerNavTabs: true,
      requiresAuth: true
    },
    beforeEnter: requiresPA,
    component: () =>
      import(
        /* webpackChunkName: "archived-customers" */ "@/views/assistant/ArchivedCustomers.vue"
      )
  },
  {
    path: "/tasks/weekly-tasks/:profileId",
    name: "PAWeeklyTasks",
    beforeEnter: requiresPA,
    meta: {
      tasks: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "ea-weekly-tasks" */ "@/views/common/tasks/weekly/PAWeeklyTasks.vue"
      )
  },
  {
    path: "/weekly-tasks/:profileId/add-weekly-task",
    name: "AddWeeklyTask",
    beforeEnter: requiresPA,
    meta: {
      tasks: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "add-weekly-task" */ "@/views/common/tasks/weekly/AddWeekly.vue"
      )
  },
  {
    path: "/weekly-tasks/:assistantId/details/:notesId",
    name: "ViewWeeklyTask",
    meta: {
      tasks: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "view-weekly-task" */ "@/views/common/tasks/weekly/ViewEditWeekly.vue"
      )
  },

  {
    path: "/ea/:uuid/add-task/:statusID/:frequency",
    name: "AddPATask",
    meta: {
      assistants: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "ea-add-task" */ "@/views/common/AddTasks.vue"
      )
  },
  {
    path: "/ea/:uuid/customer-details/:profileId/add-task/:statusID/:frequency",
    name: "AddPACustomerTask",
    meta: {
      assistants: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "ea-customer-add-task" */ "@/views/common/AddTasks.vue"
      )
  },
  {
    path: "/search",
    name: "Search",
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "ea-customer-add-task" */ "@/views/common/search/Search.vue"
      )
  },
  {
    path: "/404",
    name: "404",
    meta: {
      assistants: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "ea-customer-add-task" */ "@/views/404/NotFound.vue"
      )
  },
  {
    path: "/403",
    name: "403",
    meta: {
      assistants: true,
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "ea-customer-add-task" */ "@/views/404/NotFound.vue"
      )
  }
];
